import model from 'modules/eboxModule/eboxModuleModel';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.code,
  fields.eboxModuleCompartiment,
  fields.enable,
  fields.createdAt,
  fields.updatedAt
];
